import React from "react";
import { MenaVstupy, PercentaVstupy, IntegerVstupy } from "../vstupneKomponenty";

export default function InvesticneRentaVstupKarta({
  investRentaOpen,
  rentaKapital,
  setRentaKapital,
  rentaKapitalRoky,
  setRentaKapitalRoky,
  rentaKapitalZhodnotenie,
  setRentaKapitalZhodnotenie,
  rentaMesacne,
  setRentaMesacne,
  rentaMesacneRoky,
  setRentaMesacneRoky,
  rentaMesacneZhodnotenie,
  setRentaMesacneZhodnotenie,
}) {
  if (!investRentaOpen) return null;

  return (
    <div className="card-section card-section--invest-renta card-section--invest-renta-vstup">
      <h2>Renta</h2>

      <div className="invest-renta-vstup-grid">
        <div className="invest-renta-medziriadok">
          Aká bude výška mesačnej renty?
        </div>

        <div className="invest-renta-input-row">
          <div className="invest-renta-row-title">
            Z kapitálu na rentu
          </div>

          <div className="form form--m">
            <label className="form_label">Vlastný kapitál</label>

            <MenaVstupy
              value={rentaKapital}
              onChange={(v) =>
                setRentaKapital(Math.min(9999999, Math.max(0, v)))
              }
              maxDigits={7}
              suffix="€"
              placeholder="0"
            />
          </div>

          <div className="form form--m">
            <label className="form_label">Dĺžka vyplácania (r)</label>

            <IntegerVstupy
              value={rentaKapitalRoky}
              onChange={(v) =>
                setRentaKapitalRoky(Math.min(30, Math.max(0, v)))
              }
              maxDigits={2}
              min={0}
              max={30}
              placeholder=" "
            />
          </div>

          <div className="form form--m">
            <label className="form_label">Zhodnotenie p.a.</label>

            <PercentaVstupy
              value={rentaKapitalZhodnotenie}
              onChange={(v) =>
                setRentaKapitalZhodnotenie(Math.min(10, Math.max(0, v)))
              }
              maxInt={2}
              placeholder=" "
            />
          </div>
        </div>

        <div className="invest-renta-medziriadok">
          Koľko vlastného kapitálu potrebujem na mesačnú rentu?
        </div>

        <div className="invest-renta-input-row">
          <div className="invest-renta-row-title">
            Z renty na kapitál
          </div>

          <div className="form form--m">
            <label className="form_label">Chcem mesačnú rentu</label>

            <MenaVstupy
              value={rentaMesacne}
              onChange={(v) =>
                setRentaMesacne(Math.min(9999, Math.max(0, v)))
              }
              maxDigits={4}
              suffix="€"
              placeholder="0"
            />
          </div>

          <div className="form form--m">
            <label className="form_label">Dĺžka vyplácania (r)</label>

            <IntegerVstupy
              value={rentaMesacneRoky}
              onChange={(v) =>
                setRentaMesacneRoky(Math.min(30, Math.max(0, v)))
              }
              maxDigits={2}
              min={0}
              max={30}
              placeholder=" "
            />
          </div>

          <div className="form form--m">
            <label className="form_label">Zhodnotenie p.a.</label>

            <PercentaVstupy
              value={rentaMesacneZhodnotenie}
              onChange={(v) =>
                setRentaMesacneZhodnotenie(Math.min(10, Math.max(0, v)))
              }
              maxInt={2}
              placeholder=" "
            />
          </div>
        </div>
      </div>
    </div>
  );
}